// Import SASS
import '../sass/style.scss'

// Node_modules
import objectFitImages from 'object-fit-images'

import headerScroll from './modules/header'

// Import scripts
import './modules/skip-link-focus-fix'
import initYoutubeVideos from './modules/init-after-youtube-api' // when videos are loaded on the page

import '../partials/navigation/menus/menus'
// import '../partials/search/search'
import initSliders from '../partials/sliders/sliders'
import { initBlockSlider } from '../partials/blocks/block/block-slider'

window.onYouTubeIframeAPIReady = function() {
	initYoutubeVideos();
}

import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init();

// Object-fit fix
objectFitImages()

headerScroll('.header');

// Init slider
let sliders = initSliders();
console.log(sliders);

// Expertise items click event
const expertises = document.querySelectorAll('.card__expertise');
for (let i = 0; i < expertises.length; i++) {
    expertises[i].addEventListener('click', (event) => {
        if (!event.target.classList.contains('wp-block-button__link')) {
            expertises[i].classList.toggle('active');
        }
    });
}

if (document.getElementById('purpose__slider-rows')) {

window.addEventListener( 'load', function() {

  var box1 = document.getElementById('purpose__slider-row1'),
      docHeight = document.documentElement.offsetHeight,
      windowWidth = window.innerWidth/100;

    var box2 = document.getElementById('purpose__slider-row2'),
      docHeight = document.documentElement.offsetHeight,
      windowWidth = window.innerWidth/100;

    var box3 = document.getElementById('purpose__slider-row3'),
      docHeight = document.documentElement.offsetHeight,
      windowWidth = window.innerWidth/100;

    var box4 = document.getElementById('purpose__slider-row4'),
      docHeight = document.documentElement.offsetHeight,
      windowWidth = window.innerWidth/100;
  
  window.addEventListener( 'scroll', function() {
        // normalize scroll position as percentage
    var scrolled = windowWidth*(window.scrollY / ( docHeight - window.innerHeight ))*3,
        transformValue1= 'translateX('+scrolled+'px)',
        transformValue2 = 'translateX(-'+scrolled+'px)',
        transformValue3= 'translateX('+scrolled+'px)';

    box1.style.WebkitTransform = transformValue1;
    box1.style.MozTransform = transformValue1;
    box1.style.OTransform = transformValue1;
    box1.style.transform = transformValue1;

    box2.style.WebkitTransform = transformValue2;
    box2.style.MozTransform = transformValue2;
    box2.style.OTransform = transformValue2;
    box2.style.transform = transformValue2;

    box3.style.WebkitTransform = transformValue3;
    box3.style.MozTransform = transformValue3;
    box3.style.OTransform = transformValue3;
    box3.style.transform = transformValue3;

    box4.style.WebkitTransform = transformValue2;
    box4.style.MozTransform = transformValue2;
    box4.style.OTransform = transformValue2;
    box4.style.transform = transformValue2;
    
  }, false);
  
}, false);

}